import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Transaction_Menu } from "../../Connections/Transaction";

import "../../Styles/NavBar.css";

const Navbar = () => {
  const [menu, setMenu] = useState([]);

  useEffect(() => {
    Transaction_Menu.Menu().then((res) => {
      if (res[0]) setMenu(res[2].data);
    });
  }, []);

  return (
    <nav className="NavBar_wrapper">
      <input type="checkbox" id="hamburger-menu-input" hidden />
      <div className="NavBar_wrapper-logo-wrapper">
        <Link to="/">
          <img src="/imgs/Landing/Logo.svg" alt="Ketabno Logo" />
        </Link>
      </div>
      <div className="NavBar_wrapper-menu-wrapper">
        <ul className="NavBar_wrapper-menu-list">
          {menu.map((item) => (
            <li className="NavBar_wrapper-menu-item" key={item.id}>
              <Link className={item.id == 1 ? "active" : ""} to={item.link}>
                {item.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <label
        htmlFor="hamburger-menu-input"
        className="NavBar_wrapper-hamburger-menu-button"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.1001 6C4.1001 5.68174 4.22653 5.37652 4.45157 5.15148C4.67661 4.92643 4.98184 4.8 5.3001 4.8H19.7001C20.0184 4.8 20.3236 4.92643 20.5486 5.15148C20.7737 5.37652 20.9001 5.68174 20.9001 6C20.9001 6.31826 20.7737 6.62349 20.5486 6.84853C20.3236 7.07357 20.0184 7.2 19.7001 7.2H5.3001C4.98184 7.2 4.67661 7.07357 4.45157 6.84853C4.22653 6.62349 4.1001 6.31826 4.1001 6ZM4.1001 12C4.1001 11.6817 4.22653 11.3765 4.45157 11.1515C4.67661 10.9264 4.98184 10.8 5.3001 10.8H19.7001C20.0184 10.8 20.3236 10.9264 20.5486 11.1515C20.7737 11.3765 20.9001 11.6817 20.9001 12C20.9001 12.3183 20.7737 12.6235 20.5486 12.8485C20.3236 13.0736 20.0184 13.2 19.7001 13.2H5.3001C4.98184 13.2 4.67661 13.0736 4.45157 12.8485C4.22653 12.6235 4.1001 12.3183 4.1001 12ZM4.1001 18C4.1001 17.6817 4.22653 17.3765 4.45157 17.1515C4.67661 16.9264 4.98184 16.8 5.3001 16.8H19.7001C20.0184 16.8 20.3236 16.9264 20.5486 17.1515C20.7737 17.3765 20.9001 17.6817 20.9001 18C20.9001 18.3183 20.7737 18.6235 20.5486 18.8485C20.3236 19.0736 20.0184 19.2 19.7001 19.2H5.3001C4.98184 19.2 4.67661 19.0736 4.45157 18.8485C4.22653 18.6235 4.1001 18.3183 4.1001 18Z"
            fill="white"
          />
        </svg>
      </label>
      <div className="NavBar_wrapper-mobile-menu-wrapper">
        <div className="NavBar_wrapper-mobile-menu-wrapper-content">
          <div className="NavBar_wrapper-mobile-menu-wrapper-top">
            <label htmlFor="hamburger-menu-input">
              <img src="imgs/Landing/Logo-dark.svg" alt="Ketabno Logo" />
            </label>
          </div>
          <div className="NavBar_wrapper-mobile-menu-list">
            {menu.map((item) => (
              <Link
                id={item.link === "/hisstori/home" && "startEdventure1"}
                key={item.id}
                to={item.link}
                className={`${
                  item.id == 1 ? "active" : ""
                } NavBar_wrapper-mobile-menu-list-item ${
                  item.link === "/hisstori/home" && "start-edventure-btn"
                }`}
              >
                {console.log(item)}
                {item.name}
              </Link>
            ))}
          </div>
          <div className="NavBar_wrapper-mobile-menu-wrapper-bottom">
            <p>نسخه 0.1</p>
          </div>
        </div>
        <label
          htmlFor="hamburger-menu-input"
          className="NavBar_wrapper-mobile-menu-wrapper-close"
        ></label>
      </div>
      <div className="nav-bar-hidden">{/* for alignment header  */}</div>
    </nav>
  );
};

export default Navbar;
